/**
 * Module description...
 *
 * @returns {{init: init}}
 */
const MainNav = (() => {

	const DOM = {};
	let buttonReturn;

	const cacheDOM = () => {

		DOM.hamburger      = document.getElementsByClassName( "nav-toggle" );
		DOM.toggleNav      = document.getElementsByClassName( "main-menu" );
		DOM.html					 = document.querySelector( "html" );
		DOM.subMenuToggles = document.querySelectorAll(
			"#menu-main-menu li.menu-item-has-children > a"
		);
	};

	const openNav = () => {
		DOM.html.classList.add( "main-menu-open" );
		DOM.hamburger[0].classList.add( "open" );
		DOM.toggleNav[0].classList.add( "active" );
	}

	const closeNav = () => {
		DOM.html.classList.remove( "main-menu-open" );
		DOM.hamburger[0].classList.remove( "open" );
		DOM.toggleNav[0].classList.remove( "active" );

		DOM.subMenuToggles.forEach(
			(item) => {
            if (item.nextElementSibling.classList.contains( "open" )) {
                item.nextElementSibling.classList.remove( "open" );
            }
			}
		);
	removeAllParentElements();
	}

	const isNavOpen = () => {
		return DOM.hamburger[0].classList.contains( "open" );
	}

	const toggleNav = () => {
		if ( ! isNavOpen()) {
			openNav();
		} else {
			closeNav();
		}
	};

	const createParentElement = (event) => {
		const subMenu         = event.nextElementSibling;
		const subMenuChild    = subMenu.childNodes[1];

		// Bugfix for creating more Return buttons
		if (event.nextElementSibling.firstElementChild.classList.contains( 'menu-item__return' )) {
			return;
		}

		const mainLi      = document.createElement( "li" );
		mainLi.className += "menu-item__main";
		mainLi.innerHTML  =
		'<a href="' + event.href + '">' + event.innerText + "</a>";

		const returnLi      = document.createElement( "li" );
		returnLi.className += "menu-item__return";
		returnLi.innerHTML  = "<button>RETURN</button>";

		subMenu.insertBefore( returnLi, subMenuChild );
		subMenu.insertBefore( mainLi, subMenuChild );
	};

	const removeAllParentElements = () => {

		let mainMenu   = document.querySelector( ".menu-item__main" );
		let returnMenu = document.querySelector( ".menu-item__return" );

		if (mainMenu) {
			mainMenu.parentElement.removeChild( mainMenu );
			returnMenu.parentElement.removeChild( returnMenu );
		}
	}

	const openSubMenu = (event) => {
		event.preventDefault();
		event.currentTarget.nextElementSibling.classList.toggle( "open" );

		createParentElement( event.target );
		buttonReturnListeners();
	};

	const closeSubMenu = (event) => {
		event.currentTarget.parentElement.classList.toggle( "open" );
		removeAllParentElements();

		// Create buttons when going back from 3 to 2 level menu
		if (event.target.offsetParent) {
			createParentElement( event.target.offsetParent.offsetParent.offsetParent.previousElementSibling )
		}
		buttonReturnListeners();
	};

	const buttonReturnListeners = () => {

		buttonReturn = document.querySelectorAll(
			"#menu-main-menu li.menu-item__return"
		);

		Array.from( buttonReturn ).forEach(
			(HTMLNode) => {
            HTMLNode.addEventListener( "click", closeSubMenu );
			}
		);
	}

	const eventListeners = () => {

		let addMobileNavEventListeners = (windowWidth) => {
			DOM.hamburger[0].addEventListener( "click", toggleNav );
			Array.from( DOM.subMenuToggles ).forEach(
				(HTMLNode) => {
					if (windowWidth < 1200) {
						HTMLNode.addEventListener( "click", openSubMenu );
					} else {
						HTMLNode.removeEventListener( "click", openSubMenu );
					}
				}
			);
		}

		let windowWidth = document.documentElement.clientWidth;
		closeNav();
		addMobileNavEventListeners( windowWidth );

		window.addEventListener(
			"resize",
			function(){
				windowWidth = document.documentElement.clientWidth;
				closeNav();
				addMobileNavEventListeners( windowWidth );
			}
		);
	};

	const init = () => {
		cacheDOM();
		eventListeners();
	};

	return {
		init,
	};
})();

export default MainNav;
